import { SiteContent } from './types';

export const contentTR: SiteContent = {
    home: {
        heroTitle: "Geleceği Şekillendiren Dijital Çözümler",
        heroSubtitle: "İşletmenizi bir üst seviyeye taşıyacak özel yazılım ve tasarım hizmetleri.",
        heroVideoUrl: "https://cdn.pixabay.com/video/2019/04/23/23011-332483109_large.mp4",
        techStack: ["Node.js", "React", "Python", "AWS", "Flutter", "TypeScript", "Go"],
        ctaTitle: "Hayalinizdeki Projeyi Hayata Geçirelim",
        ctaDesc: "Teknolojik altyapımız ve uzman ekibimizle işletmenizi büyütmek için hazırız. Hemen teklif alın, dijital dönüşüme başlayın."
    },
    about: {
        heroTitle: "Geleceği Kodluyoruz",
        heroSubtitle: "GreySoftware olarak, işletmelerin dijital dönüşüm süreçlerine liderlik ediyor, karmaşık problemleri zarif kod satırlarına dönüştürüyoruz.",
        missionTitle: "Misyon & Vizyonumuz",
        missionDesc: "Teknoloji dünyasında iz bırakmak ve sürdürülebilir, ölçeklenebilir çözümler üretmek için çalışıyoruz.",
        timeline: [
            { id: 1, year: "2014", title: "Kuruluş", desc: "İstanbul'da 3 kişilik bir ekip olarak yola çıktık." },
            { id: 2, year: "2016", title: "İlk Global Proje", desc: "Londra merkezli bir fintech girişimi için ilk yurt dışı projemizi teslim ettik." },
        ]
    },
    services: {
        heroTitle: "Dijital Geleceğinizi İnşa Ediyoruz",
        heroSubtitle: "İşletmenizi dijital dünyada bir adım öne taşıyacak, ölçeklenebilir yazılım mimarileri ve kullanıcı odaklı tasarım çözümleri sunuyoruz.",
        processSteps: [
            { id: 1, title: "1. Keşif ve Analiz", desc: "İhtiyaçlarınızı dinliyor, pazar araştırması yapıyor ve yol haritasını belirliyoruz." },
            { id: 2, title: "2. UI/UX Tasarım", desc: "Kullanıcı deneyimi odaklı, modern ve etkileşimli prototipler hazırlıyoruz." },
            { id: 3, title: "3. Geliştirme", desc: "En güncel teknolojilerle temiz, güvenli ve performanslı kod yazıyoruz." },
            { id: 4, title: "4. Test ve Yayın", desc: "Titiz test süreçlerinin ardından projenizi canlıya alıyor ve destekliyoruz." },
        ]
    },
    projects: {
        heroTitle: "Başarı Hikayelerimiz",
        heroSubtitle: "Farklı sektörlerdeki iş ortaklarımız için geliştirdiğimiz, teknoloji ve tasarımın mükemmel uyumunu yansıtan projelerimizi inceleyin.",
        ctaTitle: "Sizin Projeniz Sırada Olsun",
        ctaDesc: "İşletmeniz için özel çözümler üretmeye hazırız. Teknolojik dönüşüm yolculuğunuzda size eşlik edelim."
    },
    contact: { heroTitle: "Bir Sonraki Büyük Projenizi Birlikte İnşa Edelim", heroSubtitle: "Sorularınız, proje fikirleriniz veya sadece merhaba demek için buradayız." },
    footer: { desc: "Yenilikçi yazılım çözümleri ile işletmelerin dijital potansiyelini ortaya çıkarıyoruz.", copyright: "© 2024 GreySoftware. Tüm hakları saklıdır." }
};

export const contentEN: SiteContent = {
    home: {
        heroTitle: "Shaping the Future with Digital Solutions",
        heroSubtitle: "Custom software and design services to take your business to the next level.",
        heroVideoUrl: "https://cdn.pixabay.com/video/2019/04/23/23011-332483109_large.mp4",
        techStack: ["Node.js", "React", "Python", "AWS", "Flutter", "TypeScript", "Go"],
        ctaTitle: "Let's Bring Your Dream Project to Life",
        ctaDesc: "We are ready to grow your business with our technological infrastructure and expert team. Get a quote now, start the digital transformation."
    },
    about: {
        heroTitle: "Coding the Future",
        heroSubtitle: "As GreySoftware, we lead the digital transformation processes of businesses and transform complex problems into elegant lines of code.",
        missionTitle: "Our Mission & Vision",
        missionDesc: "We strive to leave a mark in the world of technology and produce sustainable, scalable solutions.",
        timeline: [
            { id: 1, year: "2014", title: "Foundation", desc: "We started as a team of 3 in Istanbul." },
            { id: 2, year: "2016", title: "First Global Project", desc: "We delivered our first international project for a London-based fintech startup." },
        ]
    },
    services: {
        heroTitle: "Building Your Digital Future",
        heroSubtitle: "We offer scalable software architectures and user-oriented design solutions that will take your business one step ahead in the digital world.",
        processSteps: [
            { id: 1, title: "1. Discovery & Analysis", desc: "We listen to your needs, conduct market research, and determine the roadmap." },
            { id: 2, title: "2. UI/UX Design", desc: "We prepare modern and interactive prototypes focused on user experience." },
            { id: 3, title: "3. Development", desc: "We write clean, secure, and performant code with the latest technologies." },
            { id: 4, title: "4. Test & Launch", desc: "After rigorous testing processes, we launch and support your project." },
        ]
    },
    projects: {
        heroTitle: "Our Success Stories",
        heroSubtitle: "Examine the projects we developed for our business partners in different sectors, reflecting the perfect harmony of technology and design.",
        ctaTitle: "Let Your Project Be Next",
        ctaDesc: "We are ready to produce custom solutions for your business. Let us accompany you on your technological transformation journey."
    },
    contact: { heroTitle: "Let's Build Your Next Big Project Together", heroSubtitle: "We are here for your questions, project ideas, or just to say hello." },
    footer: { desc: "We reveal the digital potential of businesses with innovative software solutions.", copyright: "© 2024 GreySoftware. All rights reserved." }
};

export const contentIT: SiteContent = {
    home: {
        heroTitle: "Innovazione Digitale per il Futuro",
        heroSubtitle: "Sviluppiamo soluzioni software su misura e design d'avanguardia per elevare il tuo business al livello successivo nel cuore di Milano.",
        heroVideoUrl: "https://cdn.pixabay.com/video/2019/04/23/23011-332483109_large.mp4",
        techStack: ["Node.js", "React", "Python", "AWS", "Flutter", "TypeScript", "Go"],
        ctaTitle: "Realizziamo il Progetto dei Tuoi Sogni",
        ctaDesc: "Siamo pronti a far crescere la tua azienda con la nostra infrastruttura tecnologica e il nostro team di esperti italiani. Richiedi un preventivo oggi stesso."
    },
    about: {
        heroTitle: "Codifichiamo il Futuro",
        heroSubtitle: "In GreySoftware S.r.l., guidiamo la trasformazione digitale delle aziende italiane ed europee, trasformando problemi complessi in eleganti righe di codice.",
        missionTitle: "La Nostra Missione",
        missionDesc: "Ci impegniamo a lasciare un segno nel mondo della tecnologia, producendo soluzioni sostenibili e scalabili che riflettono l'eccellenza del design italiano.",
        timeline: [
            { id: 1, year: "2014", title: "Fondazione", desc: "Siamo partiti come una startup di 3 persone a Milano." },
            { id: 2, year: "2016", title: "Primo Progetto Globale", desc: "Abbiamo consegnato il nostro primo progetto internazionale per una fintech di Londra." },
            { id: 3, year: "2019", title: "Centro R&S", desc: "Abbiamo ottenuto lo status ufficiale di centro di ricerca e sviluppo." },
            { id: 4, year: "2023", title: "Espansione", desc: "Uffici in 3 paesi e un team di oltre 40 esperti." },
        ]
    },
    services: {
        heroTitle: "Costruiamo il Tuo Futuro Digitale",
        heroSubtitle: "Offriamo architetture software scalabili e soluzioni di design orientate all'utente che porteranno la tua azienda un passo avanti nel mercato globale.",
        processSteps: [
            { id: 1, title: "1. Analisi e Strategia", desc: "Ascoltiamo le tue esigenze, analizziamo il mercato e definiamo la roadmap perfetta." },
            { id: 2, title: "2. Design UI/UX", desc: "Creiamo prototipi interattivi e moderni focalizzati sulla migliore esperienza utente." },
            { id: 3, title: "3. Sviluppo Agile", desc: "Scriviamo codice pulito, sicuro e performante utilizzando le ultime tecnologie." },
            { id: 4, title: "4. Test e Lancio", desc: "Dopo rigorosi test di qualità, lanciamo il progetto e offriamo supporto continuo." },
        ]
    },
    projects: {
        heroTitle: "Le Nostre Storie di Successo",
        heroSubtitle: "Scopri i progetti che abbiamo sviluppato per i nostri partner, riflettendo la perfetta armonia tra tecnologia avanzata e design italiano.",
        ctaTitle: "Il Tuo Progetto Sarà il Prossimo?",
        ctaDesc: "Siamo pronti a creare soluzioni personalizzate per la tua azienda. Accompagnaci nel tuo viaggio di trasformazione digitale."
    },
    contact: { heroTitle: "Costruiamo Insieme Qualcosa di Grande", heroSubtitle: "Siamo qui per rispondere alle tue domande, discutere idee o semplicemente per un caffè nel nostro ufficio a Milano." },
    footer: { desc: "Sblocchiamo il potenziale digitale delle aziende con soluzioni software innovative e creative.", copyright: "© 2024 GreySoftware S.r.l. Tutti i diritti riservati." }
};
